import React from 'react';

import { LazyJiraMacroRepairPage } from '@confluence/site-settings/entry-points/JiraMacroRepairPage.ts';
import { ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE } from '@confluence/site-settings/entry-points/jiraRepairMacroConstants.ts';
import { ADMIN_HOME_ID } from '@confluence/app-navigation/entry-points/navigationIDs.ts';

export const AdminJiraMacroRepairRoute: {
	(): React.JSX.Element;
	NAVIGATION_PARAMS(): {
		Screen: {
			screenEvent: {
				name: string;
			};
		};
		MainLayout: {
			navView: string;
		};
	};
} = (): React.JSX.Element => <LazyJiraMacroRepairPage />;

AdminJiraMacroRepairRoute.NAVIGATION_PARAMS = (): {
	Screen: {
		screenEvent: {
			name: string;
		};
	};
	MainLayout: {
		navView: string;
	};
} => ({
	Screen: {
		screenEvent: { name: ADMIN_JIRA_MACRO_REPAIR_ANALYTICS_SOURCE },
	},
	MainLayout: {
		navView: ADMIN_HOME_ID,
	},
});
